export default __webpack_public_path__ + "static/media/w1.5b419446.png";